import React from "react";
import * as MUIStyled from "../../../MUIStyled";
import * as Styled from "../../../CompanyForm.styled";
import { ButtonText } from "../../elements/Buttons/Buttons.js";

export const CustomReviewDetail = ({
    title,
    data,
    dataType,
    dropdownLabels,
    onEdit,
    areButtonsDisabled,
}) => {
    // Helper function to remove ID suffix from specific keys
    const removeIDSuffix = (key) => {
        const keysToClean = [
            "employerMethodID",
            "accountingSoftwareID",
            "industryTypeID",
            "companyTypeId",
        ];

        if (keysToClean.includes(key)) {
            return key.replace(/ID$/i, "");
        }
        return key;
    };

    // Helper function to format date from YYYY-MM-DD to DD/MM/YYYY
    const formatDate = (dateString) => {
        if (!dateString || typeof dateString !== "string") return dateString;

        const dateMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (dateMatch) {
            const [, year, month, day] = dateMatch;
            return `${day}/${month}/${year}`;
        }
        return dateString;
    };

    // Helper function to get label name from ID
    const getLabelFromId = (key, id) => {
        if (!dropdownLabels || !id) return "N/A";

        // Handle id: 1 as N/A for employerMethodID only (no selection made)
        if (key === "employerMethodID" && parseInt(id, 10) === 1) {
            return "N/A";
        }

        // Map keys to their corresponding dropdown arrays
        const keyToArrayMap = {
            employerMethodID: "companyEmployerMethods",
            accountingSoftwareID: "accountingSoftware",
            industryTypeID: "industries",
            companyTypeId: "companyTypes",
        };

        const arrayKey = keyToArrayMap[key];
        if (!arrayKey || !dropdownLabels[arrayKey]) return id;

        // Find the matching item by id
        const item = dropdownLabels[arrayKey].find(
            (option) => option.id === parseInt(id, 10) || option.id === id
        );

        return item ? item.name : "N/A";
    };

    return (
        <Styled.ReviewMainWrapper style={{ margin: "0 0 30px 0" }}>
            {title && (
                <Styled.ReviewTitleBox style={{ margin: "0 0 30px 0" }}>
                    <Styled.DialogBoxTitle>{title}</Styled.DialogBoxTitle>
                    {!areButtonsDisabled && (
                        <ButtonText
                            onClick={
                                typeof onEdit === "function" ? onEdit : () => {}
                            }>
                            Edit
                        </ButtonText>
                    )}
                </Styled.ReviewTitleBox>
            )}

            {dataType === "EFT" && (
                <Styled.BodyText
                    style={{
                        width: "100%",
                        fontSize: "16px",
                        textAlign: "left",
                        lineHeight: "1",
                    }}>
                    EFT is selected, no further information available for EFT
                    payment method.
                </Styled.BodyText>
            )}

            <MUIStyled.CustomGrid
                container
                spacing={1}>
                {data &&
                    Object.entries(data).map(([key, value], index) => {
                        if (key === "title") return null;

                        // Skip rendering if value is null, undefined, or empty string
                        if (
                            value === null ||
                            value === undefined ||
                            value === ""
                        )
                            return null;

                        // Format the key to display nicely
                        const displayKey = removeIDSuffix(key)
                            .replace(/([A-Z])/g, " $1")
                            .replace(/_/g, " ")
                            .replace(/\b\w/g, (l) => l.toUpperCase());

                        // Handle nested object gracefully
                        const isNestedObject =
                            typeof value === "object" && value !== null;

                        // Format date if key is nextPayrollAt
                        let displayValue = isNestedObject
                            ? "N/A"
                            : value || "N/A";

                        if (key === "nextPayrollAt" && !isNestedObject) {
                            displayValue = formatDate(value) || "N/A";
                        }

                        // Map ID to label name for specific keys
                        const idKeys = [
                            "employerMethodID",
                            "accountingSoftwareID",
                            "industryTypeID",
                            "companyTypeId",
                        ];
                        if (idKeys.includes(key) && !isNestedObject) {
                            displayValue = getLabelFromId(key, value) || "N/A";
                        }

                        return (
                            <MUIStyled.CustomGrid
                                item
                                xs={12}
                                sm={6}
                                md={3}
                                lg={3}
                                key={index}>
                                <Styled.ReviewCompanyRows
                                    style={{ margin: "0 0 10px 0" }}>
                                    <Styled.BodyText
                                        style={{
                                            fontSize: "16px",
                                            fontWeight: "600",
                                            textAlign: "left",
                                            lineHeight: "1",
                                        }}>
                                        {displayKey}
                                    </Styled.BodyText>
                                    <Styled.BodyText
                                        style={{
                                            width: "170px",
                                            fontSize: "16px",
                                            fontWeight: "400",
                                            textAlign: "left",
                                            lineHeight: "1",
                                        }}>
                                        {displayValue}
                                    </Styled.BodyText>
                                </Styled.ReviewCompanyRows>
                            </MUIStyled.CustomGrid>
                        );
                    })}
            </MUIStyled.CustomGrid>
        </Styled.ReviewMainWrapper>
    );
};
